// src/app/page.tsx
import React, { useEffect, useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { Article, CategoriasString, GetArticulosPorFiltro, ModoBusqueda, ModoUbicacion, SubCategoriasID } from '@/objects/Articles';
import ArticulosQueries from '@/network/Articulos';
import { HeadObj } from '@/objects/Page';
import ListaArticulos from '@/components/elements/listas/lista_articulos/ListaArticulos';
import { addArticuloInternoToArticles, crearJSONLDCatalogo, numeroCajasPorDefecto, obtenerCategoriaIDByString, obtenerIdUltimoTotal, obtenerSubCategoriaIdByString, obtenerSubCategoriaStringByCategoriaID, obtenerUltimaDistanciaDelUltimoArticulo, obtenerUltimoDateByArticles } from '@/util/Articulos';
import { useServices } from '@/context/ServicesProvider';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { pathToSection, traduccionesPorPathHead } from '@/util/internacionalizacion/TraduccionesPorPath';
import { getCookiePais } from '@/util/CookieStorage';
import ContenidoPrincipal from '@/components/elements/ContenidoPrincipal';
import BannerAmazoneBooks from '@/components/widgets/BannerAmazoneBooks';
import ListaCategorias from '@/components/elements/listas/lista_categorias/ListaCategorias';
import ListaDestacados from '@/components/elements/listas/lista_destacados/ListaDestacados';
import { axiosBaseURLAPI } from '@/util/NetworkInstance';
import Subtitulo from '@/components/elements/Subtitulo';
import LibrosCercanos, { TipoUbicacion } from '@/components/widgets/LibrosCercanos';
import { getUbicacion } from '@/util/Ubicacion';
import { LocalizacionObj } from '@/objects/Localizacion';
import { addArticuloAmazonToArticles } from '@/util/Amazon';
import GoogleAds, { AdSenseFormat } from '@/components/widgets/Adsense/GoogleAds';
import { IDAdsense, SlotAnuncioDisplay, urlWeb } from '@/util/BaseURL';
import { idiomasDisponibles } from '@/util/Comun';
import RowNoData from '@/components/elements/RowNoData';

interface HomeProps {
  articulosIniciales: boolean;
  articles: Article[];
  pathActual: string;
  categoriaActual: string;
  subCategoriaActual?: string;
}
const Home: React.FC<HomeProps> = ({ articulosIniciales, articles, pathActual, categoriaActual, subCategoriaActual }) => {

  const { t } = useTranslation();

  const { articulosQueries } = useServices();

  const [articlesState, setArticlesState] = useState(articles);

  //Para usar ubicacion
  const [tipoUbicacion, setTipoUbicacion] = useState<TipoUbicacion>(TipoUbicacion.ULTIMOS_LIBROS);
  //Con esto evitamos que se ejecute el useEffect en la primera renderización
  const isFirstRender = useRef(true);
  const isFirstRender2 = useRef(true);
  const isFirstRenderPosition = useRef(true);
  const [ultimaDistance, setUltimaDistance] = useState<number>(0);

  const [position, setPosition] = useState<LocalizacionObj | null>(null);

  //Cuando cambie el path debes actualizar la lista de articulos
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setArticlesState(articles);
  }, [pathActual]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    //alert("Cambiar tipo ubicacion: " + tipoUbicacion);
    setArticlesState([]);
  }, [tipoUbicacion]);

  useEffect(() => {
    if (isFirstRender2.current) {
      isFirstRender2.current = false;
      return;
    }
    if (articulosIniciales && articlesState.length === 0) { //CUidado si no tiene libros hace esto
      if (tipoUbicacion === TipoUbicacion.ULTIMOS_LIBROS) {
        obtenerUltimosLibros();
      } else {
        //alert("Obtener libros cercanos");
        obtenerPosicionGPS();
      }
    }
  }, [articlesState, tipoUbicacion]);

  useEffect(() => {
    if (position != null) {
      // if (isFirstRenderPosition.current) {
      //   isFirstRenderPosition.current = false;
      //   return;
      // }
      obtenerUltimosLibros();
    }
  }, [position]);

  const cargarMas = () => {
    obtenerUltimosLibros();
  }

  function obtenerPosicionGPS() {
    getUbicacion().then((position) => {
      // alert("Set posicion GPS: " + JSON.stringify(position));
      setPosition(position);
    }).catch((error) => {
      console.error('Error al obtener ubicación:', error);
    });
  }

  async function obtenerUltimosLibros() {
   
    const getArticulosPorFiltro: GetArticulosPorFiltro = {
      valorcategoria: obtenerCategoriaIDByString(categoriaActual as CategoriasString),
      sub_categoria: Number(subCategoriaActual),
      modo_busqueda: tipoUbicacion === TipoUbicacion.ULTIMOS_LIBROS ? ModoBusqueda.RECIENTES : ModoBusqueda.UBICACION,
      latitud_actual: position ? position.latitude : undefined,
      longitud_actual: position ? position.longitude : undefined,
      ultima_distance: ultimaDistance,
      limit: numeroCajasPorDefecto(),
      country_code: getCookiePais(null).pais,
      last_id: Number(obtenerIdUltimoTotal(articlesState)),
      last_date: obtenerUltimoDateByArticles(articlesState)
    };

    articulosQueries?.getArticulosFiltro(getArticulosPorFiltro).then(async (response: AxiosResponse<Article[]>) => {
      if (response.status == 200) {
        //console.log('Artículos:', response.data.articles);
        //alert(JSON.stringify(response.data.articles));
        if (tipoUbicacion === TipoUbicacion.LIBROS_CERCANOS) {
          setUltimaDistance(obtenerUltimaDistanciaDelUltimoArticulo(response.data));
        }
        const articulosConAmazon = await addArticuloAmazonToArticles(response.data);
        const articulosPatrocionadores = await articulosQueries?.getArticulosPatrocinadores();
        const articulosFinal = await addArticuloInternoToArticles(articulosConAmazon, articulosPatrocionadores);

        setArticlesState([...articlesState, ...articulosFinal]);
        //setArticlesState([...articlesState, ...response.data.articles]);
      }
    }).catch((error) => {
      console.error('Error al obtener artículos:', error);
    });
  }

  const styleMargin = {
    margin: "20px"
  }

  return (
    <ContenidoPrincipal
      leftComponent={<div>Anuncio</div>}
      centerComponent={
        <>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <TituloPrincipalH1 texto={t(`contenido:${pathActual}.titulo`)} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingLeft: "10px", paddingRight: "10px" }}>
            <Subtitulo texto={t(`contenido:${pathActual}.subtitulo`)} />
          </div>
          <div style={styleMargin}>
            <BannerAmazoneBooks t={t} />
          </div>
          <div>
            <GoogleAds client={IDAdsense} slot={SlotAnuncioDisplay} format={AdSenseFormat.HORIZONTAL} dataFullWidthResponsive={true} />
          </div>
          <div style={styleMargin}>
            <ListaCategorias
              t={t}
              categoria={categoriaActual as CategoriasString}
              subcategoria={subCategoriaActual !== undefined ? obtenerSubCategoriaStringByCategoriaID(Number(subCategoriaActual) as SubCategoriasID) : undefined}
            />
          </div>
          <div style={styleMargin}>
            <ListaDestacados t={t} />
          </div>
          <div style={styleMargin}>
            <LibrosCercanos tipoUbicacion={tipoUbicacion} setTipoUbicacion={setTipoUbicacion} />
          </div>
          <div style={styleMargin}>
            {articlesState.length > 0 ?
              <ListaArticulos articles={articlesState} onClick={() => { cargarMas() }} t={t} />
              : <RowNoData texto={t('common:articulos.no_hay_articulos_categoria')} />
            }
          </div>
        </>
      }
      rightComponent={<div>Anuncio 2</div>}
    />
  );
};

export default Home;


//Generacion de articulos en el servidor para SEO
export async function getServerSideProps(context: any) {
  //Traducciones
  let { locale, params } = context;
  const { categoria } = params;

  let subCategoria = categoria.toString().split('-')[1];
  const terceraCategoria = categoria.toString().split('-')[2];

  if (terceraCategoria) {
    subCategoria = subCategoria + "-" + terceraCategoria;
  }

  //console.log('Subcategoria: ' + subCategoria);
  const subCategoriaActual = obtenerSubCategoriaIdByString(subCategoria);
  const categoriaActual = categoria.toString().split('-')[0];

  if (!locale) {
    locale = 'es'; // Reemplaza 'es' con tu localización predeterminada
  }

  const pathActual = pathToSection(context.resolvedUrl);
  //console.log('Idioma Cookie:' + getCookiePais(context));
  let headerObj: HeadObj = {
    title: '',
    descripcionKey: '',
    indexKeywords: '',
    linkIdioma: '',
    JSONLDPage: '',
    imagen: '',
    linkCanonical: '',
    alternates: []
  }

  headerObj = await traduccionesPorPathHead(context, locale);

  let articulos: Article[] = [];

  try {
    const articulosQueries = new ArticulosQueries(axiosBaseURLAPI());

    // const getArticulosInicial: GetArticlesCategoria = {
    //   valorCategoria: obtenerCategoriaIDByString(categoriaActual),
    //   favoritos: "",
    //   type_app: 1,
    //   filtro: subCategoriaActual,
    //   latitudActual: "",
    //   longitudActual: "",
    //   modoUbicacion: 0,
    //   ultimaDistance: 0,
    //   format: Format.JSON,
    //   num_cajas: numeroCajasPorDefecto(),
    //   id_ultimo_articulo: "",
    //   conBoton: "",
    //   tipo_android_app: 1,
    //   country_code: getCookiePais(context).pais
    // };

    //console.log("Carga articulos de " + subCategoriaActual)

    const getArticulosPorFiltro: GetArticulosPorFiltro = {
      valorcategoria: obtenerCategoriaIDByString(categoriaActual as CategoriasString),
      sub_categoria: Number(subCategoriaActual),
      modo_busqueda: ModoBusqueda.RECIENTES,
      latitud_actual: undefined,
      longitud_actual: undefined,
      ultima_distance: 0,
      limit: numeroCajasPorDefecto(),
      country_code: getCookiePais(context).pais,
      last_id: 0,
      last_date: ""
    };

    const response: AxiosResponse<Article[]> = await articulosQueries.getArticulosFiltro(getArticulosPorFiltro, "web-ssr-articulos-categoria");
    //console.log('Artículos:', response.data.articles);
    articulos = response.data;
    //console.log("Primer articulos: " + articulos[0].title);

    headerObj.JSONLDPage = crearJSONLDCatalogo(articulos);

    //Crea el link canonical y los alternates
    if (locale === 'es') {
      headerObj.linkCanonical = `${urlWeb}/categoria/${categoriaActual}`; // Para el idioma predeterminado, no se agrega el locale a la URL
    } else {
      headerObj.linkCanonical = `${urlWeb}/${locale}/categoria/${categoriaActual}`;
    }

    headerObj.alternates = idiomasDisponibles.map((loc) => {
      if (loc === 'es') {
        return { hreflang: loc, href: `${urlWeb}/categoria/${categoriaActual}` };
      } else {
        return { hreflang: loc, href: `${urlWeb}/${loc}/categoria/${categoriaActual}` };
      }
    });

  } catch (error) {
    console.error('Error al obtener artículos:', error);
  }

  //console.log("Devolver");

  //console.log("ServerSideTranslation " + JSON.stringify(await serverSideTranslations(locale, ['common', "contenido"])));
  return {
    props: {
      articulosIniciales: articulos.length > 0 ? true : false,
      articles: articulos,
      headerObj: headerObj, // Pasar el objeto de encabezado
      pathActual: pathActual, //Se le pasa para seleccionar las traducciones propias de esta página (dentro de contenido)
      categoriaActual: categoriaActual,
      subCategoriaActual: subCategoriaActual,
      ...(await serverSideTranslations(locale, ['common', "contenido", "header"])),
    },
    //revalidate: 60, // Regenera la página cada 60 segundos
  };
}